import { createContext, useContext } from "react";

import type { AsyncQueryStatus } from "@/ds";
import type { EmbarcacaoFicha } from "@/modules/embarcacoes/embarcacoes.types";

/** Carga única da ficha, sempre amarrada à embarcação que a originou. */
export interface EmbarcacaoFichaCarga {
  readonly embarcacaoId: string;
  readonly status: AsyncQueryStatus;
  /** Preenchida só em `success`: nenhum outro estado entrega bloco da ficha. */
  readonly ficha: EmbarcacaoFicha | null;
  /** O erro como veio, para cada seção montar a própria mensagem; `null` fora de `error` e `forbidden`. */
  readonly error: unknown;
  /** Nova carga completa da ficha ("Tentar novamente" de qualquer seção). */
  readonly reload: () => void;
}

// O contexto mora aqui, e não no Provider (.tsx), para o arquivo do componente exportar só componente.
export const EmbarcacaoFichaContext = createContext<EmbarcacaoFichaCarga | null>(null);

/** Carga compartilhada da ficha; as seções só existem dentro do `EmbarcacaoFichaProvider`. */
export function useEmbarcacaoFicha(): EmbarcacaoFichaCarga {
  const carga = useContext(EmbarcacaoFichaContext);
  if (!carga) throw new Error("useEmbarcacaoFicha exige o EmbarcacaoFichaProvider acima.");

  return carga;
}
